import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import iziToast from "izitoast";
import { useAuth } from "./AuthContext"; // adjust path if needed

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const { token, usertype, userData, socketpath } = useAuth();
    const [socket, setSocket] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [connectedUsers, setConnectedUsers] = useState({});
    const [allRoomStats, setAllRoomStats] = useState({});
    const [examStartData, setExamStartData] = useState({});
    const [examLiveStats, setExamLiveStats] = useState({});

    const [loginData, setLoginData] = useState([]);
    const [schid, setSchid] = useState("");

    const connectSocket = () => {
        if (!token) return;

        const newSocket = io(socketpath, {
            query: { token },
            transports: ["websocket"],
            reconnectionAttempts: 5,
        });

        newSocket.on("connect", () => {
            setIsConnected(true);
            console.log("Socket connected:", newSocket.id);
        });

        newSocket.on("disconnect", () => {
            setIsConnected(false);
            console.warn("Socket disconnected");
        });

        setSocket(newSocket);
    };

    const disconnectSocket = () => {
        if (socket) {
            socket.disconnect();
            setSocket(null);
        }
    };

    useEffect(() => {
        if (!token || !usertype || socket) return;
        connectSocket();
    }, [token, usertype]);

    // 👇 Custom behavior depending on user type
    useEffect(() => {
        if (!socket) {
            console.log("no socket connection, connecting to socket....");
            connectSocket();
            return;
        }

        if (usertype === "user") {
            const cuser = JSON.parse(userData);
            // const exam = cuser.exam._id;
            socket.emit("loggedin", { token, room: cuser.test._id });

            socket.on("status", (msg) => {
                console.log("User status:", msg);
                console.log("Connected to:", msg.room);
            });
            socket.on("examStarted", (msg) => {
                console.log("Exam started : ", msg);
            })

            socket.on("disconnect", () => {
                iziToast.warning({ message: "Disconnected", position: "topCenter" });
            });
        }

        if (usertype === "super_admin") {
            socket.emit("superadmin", { token, room: "admin-room" });

            socket.on("roomStats", (data) => {
                setConnectedUsers(data);
                console.log("Room stats:", data);
            });

            socket.on("allRoomStats", (data) => {
                setAllRoomStats(data);

                const now = new Date().toLocaleTimeString();
                const currentLoggedIn = data.totalLoggedIn;
                // const currentLoggedIn = Math.floor(Math.random() * 100); // Replace with real API data

                setLoginData(prev => {
                    const newData = [...prev, { time: now, count: currentLoggedIn }];
                    return newData.slice(-10); // Keep last 10 data points
                });
                console.log("All Room Stats:", data);
            });
            socket.on("examStarted", (msg) => {
                console.log("Exam started : ", msg);
            })
        }
        if (usertype === "admin") {
            console.log('joining exam room', schid);
            if(schid){
                socket.emit("join_admin", { token, room: schid });
                socket.on("status", (msg) => {
                    console.log("User status:", msg);
                    console.log("Connected to:", msg.room);
                });
            }
            socket.on('exam_stats_update', (data) => {
                console.log("live : ", data);
                setExamLiveStats(data);
            });
        }

        // Cleanup on unmount or usertype/socket change
        return () => {
            if (!socket) return;
            socket.off("status");
            socket.off("disconnect");
            socket.off("roomStats");
            socket.off("allRoomStats");
            socket.off("examStarted");
        };
    }, [usertype, socket, schid]);

    return (
        <SocketContext.Provider
            value={{
                socket,
                connectSocket,
                isConnected,
                connectedUsers,
                allRoomStats,
                loginData,
                examStartData,
                disconnectSocket,
                examLiveStats,
                setSchid,
                // emitExam,
            }}
        >
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => useContext(SocketContext);
